import React from 'react'
import { useTranslation } from 'react-i18next'
import ReadershipProfilePreviewFiltersOutputEntity from './ReadershipProfilePreviewFiltersOutputEntity'
import { ReadershipProfilePreviewInputsInterface } from '../../../../../core/interface/analytics/readership-profile-preview-inputs.interface'
import {
  CompareGroupType,
  StudyObjectType,
} from '../configs/StudiesObjectsCompareGroupTypesConfig'
import { SetColorEnum } from '../../../../../core/enums/set-color.enum'
import { SetColorConfig } from '../../../../../core/config/SetColorConfig'
import { SetColorConfigInterface } from '../../../../../core/interface/set-color-config.interface'

const ReadershipProfilePreviewFiltersOutput = ({
  previewInputs,
  studyObjectType,
  compareGroupType,
  setColor = SetColorEnum.SET_1,
}: {
  previewInputs: ReadershipProfilePreviewInputsInterface | null
  studyObjectType: StudyObjectType
  compareGroupType: CompareGroupType
  setColor?: SetColorEnum
}) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-row rounded-xl gap-4 items-stretch self-start p-4 border border-[#E9E9E9] w-full">
      <ReadershipProfilePreviewFiltersOutputEntity
        title={t('detailsReadershipProfile.studyObjectSettings')}
        type={studyObjectType}
        typeInput="studyObjectValue"
        previewInputs={previewInputs}
        color={
          SetColorConfig.find(
            (setColorConfig: SetColorConfigInterface) =>
              setColorConfig.value === setColor,
          )?.color1 || SetColorConfig[0].color1
        }
      />
      <div className="w-px bg-[#E9E9E9] self-stretch" />
      <ReadershipProfilePreviewFiltersOutputEntity
        title={t('detailsReadershipProfile.comparisonGroupSettings')}
        type={compareGroupType}
        typeInput="compareGroupValue"
        previewInputs={previewInputs}
        color={
          SetColorConfig.find(
            (setColorConfig: SetColorConfigInterface) =>
              setColorConfig.value === setColor,
          )?.color2 || SetColorConfig[0].color2
        }
      />
    </div>
  )
}

export default ReadershipProfilePreviewFiltersOutput
